class BlogPredictiveSearch extends HTMLFormElement {
    constructor() {
        super();

        this.cachedMap = new Map();
        this.focusElement = this.input;
        this.resetButton.addEventListener('click', this.clear.bind(this));
        this.input.addEventListener('input', FoxTheme.utils.debounce(this.onChange.bind(this), 300));
        this.input.addEventListener('focus', this.onFocus.bind(this));
        this.emptyTitle = this.dataset.emptyTitle;
        this.emptyMessage = this.dataset.emptyMessage;
        this.searchContent = this.querySelector('.search__content');
        this.searchField = this.querySelector('.search__field');
        this.searchResults = this.querySelector('.search__results');
        this.resultsContainer = this.querySelector('.search-results-blog');
        this.searchRecommendationEmpty = this.dataset.searchRecommendationEmpty === 'true';
        document.addEventListener('click', this.handleClickOutside.bind(this));
    }

    get input() {
        return this.querySelector('input[type="search"]');
    }

    get resetButton() {
        return this.querySelector('button[type="reset"]');
    }

    onFocus(event) {
        if (this.closest('.template-search')) {
            document.body.classList.add('blog-predictive-search-open');
            if (this.getQuery().length === 0) {
                return;
            }
            const url = this.setupURL().toString();
            this.renderSection(url, event);
        }
    }

    getQuery() {
        return this.input.value.trim();
    }

    clear(event = null) {
        event && event.preventDefault();
        if (this.searchRecommendationEmpty && this.searchContent) {
            this.searchContent.classList.add('hidden');
            this.searchContent.style.display = 'none';
            this.resultsContainer.classList.remove('active');
            this.searchResults.classList.remove('active');
        }
        this.input.value = '';
        this.input.focus();
        this.removeAttribute('results');
    }

    setupURL() {
        let localTest = window.location.hostname;
        let shopUrl = FoxTheme.routes.shop_url;
        if (localTest === 'localhost') {
            shopUrl = "http://localhost:9292"
        }
        const url = new URL(`${shopUrl}${FoxTheme.routes.predictive_search_url}.json?resources[type]=article&resources[limit]=10`);
        return (
            url.searchParams.set('q', this.getQuery()),
                url.searchParams.set('resources[limit]', this.dataset.resultsLimit || 3),
                url.searchParams.set('resources[limit_scope]', 'each'),
                url.searchParams.set('section_id', FoxTheme.utils.getSectionId(this)),
                url
        );

    }

    onChange() {
        if (this.getQuery().length === 0) {
            this.clear();
            return;
        }
        const url = this.setupURL().toString();
        this.renderSection(url);
    }

    renderSection(url) {
        this.renderSectionFromFetch(url)
    }

    renderSectionFromCache(url) {
        const responseText = this.cachedMap.get(url);
        this.renderSearchResults(responseText), this.setAttribute('results', '');
    }

    renderSectionFromFetch(url) {
        // Indicate that loading has started
        this.setAttribute('loading', 'true');
        this.resetButton.classList.add('btn--loading');
        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then((responseText) => {
                // Process and cache the fetched data
                this.renderSearchResults(responseText);
                this.cachedMap.set(url, responseText);
            })
            .catch((error) => {
                this.setAttribute('error', 'Failed to load data');
            })
            .finally(() => {
                // Remove the loading attribute in both success and error cases
                this.removeAttribute('loading');
                this.resetButton.classList.remove('btn--loading');
                this.setAttribute('results', 'true');
            });
    }

    renderSearchResults(responseText) {
        const id = 'shopify-section-' + FoxTheme.utils.getSectionId(this);
        const targetId = 'BlogPredictiveSearchResults-' + FoxTheme.utils.getSectionId(this);
        const targetElement = document.getElementById(targetId);
        let finalObject = responseText.resources.results.articles;
        if(finalObject.length === 0){

            let html = `
            <div class="empty-state flex flex-col gap-3 items-center justify-center text-center w-full h-full">
                <h4>
                    ${this.emptyTitle} “${this.getQuery()}”
                </h4>
                <p class="m-0">
                    ${this.emptyMessage}
                </p>
            </div>`;
            this.searchContent?.classList.remove('hidden');
            this.searchContent.style.display = "block";
            this.searchResults.style.display = "block";
            this.resultsContainer?.classList.add('active');
            targetElement.innerHTML = html;
            return
        }

        if (targetElement && finalObject) {
            let finalHtmlObject = '<div class="grid gap-3 w-full">'
            let htmlOutput = finalObject.map((item,index) => {
                return `
                <li id="predictive-search-option-article-${item.id}" class="predictive-search-result__list-item" role="option" aria-selected="false">
                    <div class="article-image-wrapper">
                      <img src="${item.featured_image.url}" alt="${item.featured_image.alt}" width="100" height="54">
                    </div>
                    <div class="article-description-wrapper">
                      <h5 class="article-title">${item.title}</h5>
                      <a href="${item.url}" class="reversed-link">Read Article</a>
                    </div>
                </li>
                `;
            }).join('');
            finalHtmlObject += htmlOutput+'</div>'

            if (finalHtmlObject) {
                this.searchContent?.classList.remove('hidden');
                this.searchContent.style.display = "block";
                this.searchResults.style.display = "block";
                this.resultsContainer?.classList.add('active');

                targetElement.innerHTML = finalHtmlObject;
            } else {
                this.searchContent?.classList.add('hidden');
                this.searchContent.style.display = "none";
                this.searchResults.style.display = "none";
            }
        }

    }

    handleClickOutside(event) {
        if (!this.contains(event.target)) {
            setTimeout(() => {
                this.clear()
            });
        }
    }
}

customElements.define('blog-predictive-search', BlogPredictiveSearch, {extends: 'form'});